// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MUSD","option":"styles_option__1C7Uj","selected":"styles_selected__10fzy"};